export default {"src":"/_next/static/image/public/images/flags/flag_297.d8bafb70c3ebe7822e75f4be0edb5501.svg","height":16,"width":25};